import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { BrandingContext } from './brandingHook';
import { useTenant } from '../tenant/tenantContext';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

const DEFAULT_BRANDING = {
  appName: 'KTC ISP Platform',
  logoUrl: null,
  primaryColor: '#0ea5e9',
  secondaryColor: '#22d3ee',
  themeMode: 'dark',
};

export default function BrandingProvider({ children }) {
  const { tenantId } = useTenant();
  const [branding, setBranding] = useState(DEFAULT_BRANDING);

  const refreshBranding = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/api/branding/config`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Tenant-ID': String(tenantId || 'tenant_default'),
        },
      });
      if (!res.ok) return;
      const data = await res.json();
      setBranding((prev) => ({
        ...prev,
        ...data,
      }));
    } catch {
      // keep default
    }
  }, [tenantId]);

  useEffect(() => {
    refreshBranding();
  }, [refreshBranding]);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--tenant-primary-color', String(branding.primaryColor || DEFAULT_BRANDING.primaryColor));
    root.style.setProperty('--tenant-secondary-color', String(branding.secondaryColor || DEFAULT_BRANDING.secondaryColor));
    document.title = String(branding.appName || DEFAULT_BRANDING.appName);
  }, [branding]);

  const value = useMemo(() => ({
    ...DEFAULT_BRANDING,
    ...branding,
    refreshBranding,
  }), [branding, refreshBranding]);

  return (
    <BrandingContext.Provider value={value}>
      {children}
    </BrandingContext.Provider>
  );
}

